<template>
  <div>
    <section class="hero text-center text-light">
      <div class="hero-bg"></div>
      <div class="container-sm">
        <div class="hero-inner">
          <div class="hero-copy">
            <h1 class="hero-title mt-0">
              We're all a little forgetful sometimes,
              <span class="text-primary-branded">{{ userEmail }}</span>.
            </h1>
            <p class="hero-paragraph">
              Reset your password using the form below.
            </p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  export default {
    props: {
      userEmail: String
    }
  }
</script>

<style scoped>

</style>
